import { ActionTree } from "vuex";
import { ShowSnackbar } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<ShowSnackbar, RootState> = {};
